import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp1004',
    ecrans: ['00-2'],
    params: ['doccleint']
});